(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(['exports', 'lodash/dropWhile', '../util/convert'], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require('lodash/dropWhile'), require('../util/convert'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.dropWhile, global.convert);
    global.dropWhile = mod.exports;
  }
})(this, function (exports, _dropWhile2, _convert) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = exports.dropWhile = undefined;

  var _dropWhile3 = _interopRequireDefault(_dropWhile2);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  /**
   * Replaces an array excluding elements dropped from the beginning. Elements are dropped until <code>predicate</code> returns falsey.
   * @function
   * @memberof array
   * @param {Object} object The object to modify.
   * @param {Array|string} path The path of the property to set.
   * @param {Function} [predicate={@link https://lodash.com/docs#identity|lodash.identity}] The function invoked per iteration.
   * @return {Object} Returns the updated object.
   * @example dropWhile({ nested: { prop: [1, 2, 3, 4] } }, 'nested.prop', v => v < 3) // => { nested: { prop: [3, 4] } }
   * @see {@link https://lodash.com/docs#dropWhile|lodash.dropWhile} for more information.
   * @since 0.3.0
   */
  var dropWhile = (0, _convert.convert)(_dropWhile3.default);
  exports.dropWhile = dropWhile;
  exports.default = dropWhile;
});